import React, { useEffect, useRef } from 'react';
import loadable from '@loadable/component';
import moment from 'moment-timezone';
import { List, useDynamicRowHeight } from 'react-window';
import { ImageHelper } from '../../classes/image-helper.class';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import PictureSet from '../../components/picture-set';

const RequestMorePhotos = loadable(() => import('../../components/request-more-photos'));

const itemHeight = 316;

/**
 * Renders a single row of the virtualized gallery.
 *
 * react-window v2 renders rows through a dedicated component rather than a
 * render prop, and measures each row itself via ResizeObserver, so this
 * component no longer reports its own height.
 */
const GalleryRow = ({ index, style, photos, canShowRequest, spotId, hostId, altImg, singlePhotoHandler }) => {
    if (canShowRequest && index == photos.length) {
        return (
            <div style={style} className="req-photo-comp pb-5">
                <RequestMorePhotos id={spotId} />
            </div>
        );
    }

    const p = photos[index];
    let submittedBy = '';

    if (p?.providedById !== null && p?.providedBy && hostId !== p?.providedBy.id) {
        const monthYear = moment(p.createdAt).format('MMM YYYY');
        submittedBy = `Submitted by: ${p.providedBy.firstname} ${p.providedBy.lastInitial}. - ${monthYear}`;
    }

    return (
        <div style={style} className={`photos-box ${index == photos.length - 1 ? 'pb-5' : ''}`} onClick={() => singlePhotoHandler(index)}>
            <div>
                <PictureSet
                    imgs={ImageHelper.getUrlFromOptions(p.imageAws, `fit-in/${IMG_RESIZES.x512}`)}
                    className="photos-item"
                    alt={altImg}
                    width="100%"
                    height={300}
                    method="eager"
                />
                {submittedBy && (
                    <p className="spot-detail-photos-submitted mb-0">
                        <span className="photos-text">{submittedBy}</span>
                    </p>
                )}
                {p.caption && <p className="spot-detail-photos-caption">{p.caption}</p>}
            </div>
        </div>
    );
};

const MobilePhotoGallery = ({ singlePhotoHandler, mobilePhotoCount, photos, spotId, hostId, title, state, city, canShowRequest }) => {
    const altImg = title ? `${title} - ${city}, ${state}` : 'Spot thumbnail';
    const listRef = useRef(null);
    const rowHeight = useDynamicRowHeight({ defaultRowHeight: itemHeight });

    useEffect(() => {
        setTimeout(() => {
            listRef?.current?.scrollToRow({ index: mobilePhotoCount, align: 'start' });
        }, 200);
    }, []);

    return (
        <div className="gallery-photos">
            <List
                listRef={listRef}
                rowHeight={rowHeight}
                overscanCount={4}
                rowCount={canShowRequest ? photos.length + 1 : photos.length}
                rowComponent={GalleryRow}
                rowProps={{ photos, canShowRequest, spotId, hostId, altImg, singlePhotoHandler }}
                style={{ height: '100%' }}
            />
        </div>
    );
};

export default MobilePhotoGallery;
